import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const TakeDeliveryAction = {
    /**
     * 查看预约提货信息
     * @param data
     */
    getDeliveryIniti(data={}) {
        return request({
            url: '/mg/abd/whs/deliveryOrder/get-delivery-order',
            method: "POST",
            data
        });
    },
    /**
     * 下载提货单
     * @param data
     */
    downloadDeliverOrder(data={}) {
        return request({
            url: '/service/dubbo/proxy/abd/download-deliver-order',
            method: "POST",
            data
        });
    },
    /**
     * 下载 发票
     * @param data
     */
    getDownloadCost(data={}) {
        return request({
            url: '/mg/abd/whs/deliveryOrder/download-storage-cost-invoice',
            method: "POST",
            data
        });
    },
    /**
     * 出货
     * @param data
     * http://zentao.essa.top:88/zentao/bug-view-11277.html
     */
    stockOut(data={},sUrl) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
    /**
     * 出货->详情
     * @param data
     */
    deliveryDetail(data={}) {
        return request({
            url: '/service/mg/whs/delivery/detail',
            method: "POST",
            data
        });
    },
    /**
     * 导出-下载进行中的预约单
     * @param data
     */
    downloadExcel(data={}) {
        return request({
            url: '/service/mg/whs/delivery/download-excel',
            method: "POST",
            data
        });
    },
    /**
     * 上传填充
     * @param data
     */
   uploadExcel(data={}) {
        return request({
            url: '/service/mg/whs/delivery/analysis-excel',
            method: "POST",
            data
        });
    },
    //通用接口
    post(data={},sUrl) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
};

export default TakeDeliveryAction;
